<script setup lang="ts">
import useStoreResetter from "@/hooks/useStoreResetter/useStoreResetter";
import useTranslate from "@/hooks/useTranslate/useTranslate";
import { useTIWStore } from "@/stores/tiw/tiw";
import { useVerificationStore } from "@/stores/verification/verification";
import Button from "@/ui/button/button.vue";

import Modal from "../../modal/modal.vue";

const TIWStore = useTIWStore();
const VerificationStore = useVerificationStore();

function onDifferentWay() {
    TIWStore.switchStep("successfulEvaluation");
}

function onExit() {
    useStoreResetter();
    TIWStore.switchStep("chooseDevice");
    TIWStore.closeWidget();
}

function onRepeat() {
    VerificationStore.restoreToDefault();
    TIWStore.switchStep("documentsUpload");
}
</script>

<template>
    <Modal class="tiw__step__personAuthentication">
        <div class="tiw__step__personAuthentication__body">
            <svg
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M47 40.9941V46.9941M47.027 52.9941H47M62 46.9941C62 50.9724 60.4196 54.7877 57.6066 57.6007C54.7936 60.4138 50.9782 61.9941 47 61.9941C43.0218 61.9941 39.2064 60.4138 36.3934 57.6007C33.5804 54.7877 32 50.9724 32 46.9941C32 43.0159 33.5804 39.2006 36.3934 36.3875C39.2064 33.5745 43.0218 31.9941 47 31.9941C50.9782 31.9941 54.7936 33.5745 57.6066 36.3875C60.4196 39.2006 62 43.0159 62 46.9941Z"
                    stroke="#F14459"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M56.6956 26.1621C58.1356 24.5421 60.6196 22.0941 60.4876 21.0981C60.5896 20.1291 60.0646 19.2171 59.0146 17.3961L57.5326 14.8251C56.4136 12.8811 55.8526 11.9091 54.9016 11.5251C53.9476 11.1351 52.8706 11.4411 50.7166 12.0531L47.0566 13.0821C45.6766 13.4001 44.2366 13.2201 42.9796 12.5751L41.9686 11.9931C40.891 11.3021 40.0626 10.2845 39.6046 9.08914L38.6026 6.09814C37.9426 4.11814 37.6126 3.12814 36.8326 2.55814C36.0466 1.99414 35.0026 1.99414 32.9206 1.99414H29.5786C27.4936 1.99414 26.4526 1.99414 25.6696 2.56114C24.8836 3.12814 24.5566 4.11814 23.8966 6.09814L22.8946 9.08914C22.4366 10.2845 21.6082 11.3021 20.5306 11.9931L19.5196 12.5751C18.263 13.2197 16.8193 13.4003 15.4426 13.0851L11.7826 12.0531C9.62859 11.4411 8.55159 11.1351 7.59759 11.5221C6.64659 11.9121 6.08559 12.8811 4.96659 14.8251L3.48459 17.3961C2.43459 19.2171 1.90959 20.1261 2.01459 21.0981C2.11359 22.0671 2.81559 22.8471 4.22259 24.4101L7.31259 27.8691C8.07159 28.8261 8.60859 30.4941 8.60859 31.9941C8.60859 33.4941 8.06859 35.1621 7.31559 36.1191L4.21959 39.5781C2.81259 41.1381 2.11059 41.9211 2.00859 42.8901C1.90659 43.8591 2.43159 44.7711 3.48159 46.5921L4.96359 49.1631C6.08259 51.1071 6.64359 52.0791 7.59459 52.4631C8.54859 52.8531 9.62559 52.5471 11.7796 51.9351L15.4396 50.9061C16.8196 50.5881 18.2596 50.7681 19.5196 51.4131L20.5276 51.9951C21.6046 52.6851 22.4326 53.7051 22.8916 54.8991L23.8936 57.8931C24.5536 59.8731 24.9136 60.9021 25.5166 61.3341C25.6966 61.4631 26.4166 62.0541 28.1806 62.0001"
                    stroke="#808D9A"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M38.4796 24.3381C35.9596 22.2861 33.9796 21.4941 31.0996 21.4941C25.6996 21.5661 20.7676 26.0271 20.7676 31.8261C20.7676 35.0241 21.7396 37.0461 23.5756 39.1701"
                    stroke="#808D9A"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
            <div class="tiw__step__personAuthentication__body__info">
                <p class="tiw__step__personAuthentication__body__info__title">
                    {{ useTranslate("tiw__personAuthentication__error__title") }}
                </p>
                <p class="tiw__step__personAuthentication__body__info__text">
                    {{ useTranslate("tiw__personAuthentication__error__text") }}
                </p>
            </div>
            <div class="tiw__step__personAuthentication__body__actions">
                <Button
                    class="tiw__step__personAuthentication__body__actions__differentWay"
                    @click="onDifferentWay"
                >
                    {{ useTranslate("tiw__btn__completeDifferentWay") }}
                </Button>
                <Button
                    class="tiw__step__personAuthentication__body__actions__repeat"
                    color="light"
                    @click="onRepeat"
                >
                    {{ useTranslate("tiw__person__repeatButton") }}
                </Button>
                <Button color="light" @click="onExit">
                    {{ useTranslate("tiw__btn__quit") }}
                </Button>
            </div>
        </div>
    </Modal>
</template>

<style lang="scss" src="./personAuthentication.scss"></style>
